import React from 'react';
import Modal from './Modal';
import CheckboxGroupInput from '../ui/checkbox/CheckboxGroup/CheckboxGroupInput';
import { Typography } from 'antd';

const { Text } = Typography;

const SelectNiboCompaniesModal = ({ open, companies, selected, onChange, onOk, onCancel }) => {
  // Converter para o formato de options esperado
  const options = companies.map(company => ({
    label: company.name || company.label,
    value: company.id || company.value
  }));

  return (
    <Modal
      title="Selecione as empresas Nibo"
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText="Confirmar"
      cancelText="Cancelar"
      width={600}
    >
      <div style={{ marginBottom: 16 }}>
        <Text style={{ 
          display: 'block',
          fontSize: 14,
          color: '#8c8c8c',
          marginBottom: 12
        }}>
          Selecione as empresas que deseja sincronizar com o Nibo:
        </Text>
      </div>
      
      <CheckboxGroupInput
        value={selected}
        onChange={onChange}
        options={options}
        style={{ width: '100%' }}
      />
      
     
    </Modal>
  );
};

export default SelectNiboCompaniesModal;